import { isExperimentArmActive } from '$lib/services/experiments';

/**
 *  @type {{[key: string]: import('$lib/utils/resolve-condition').Condition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	inApp: {
		condition: async (config) => {
			return new Promise((resolve) => resolve(config.meta.inApp));
		},
		resolve: async () => await import('../_in-app/Page.svelte')
	},
	lgTv: {
		condition: async (config) => {
			return new Promise((resolve) => resolve(config.meta.isSmartTvApp));
		},
		resolve: async () => await import('../_lg-tv/Page.svelte')
	},
	browser_2_0vs1_0Test1: {
		condition: async () => {
			return isExperimentArmActive('10003');
		},
		resolve: async () => await import('../_browser-3220-2_0-to-1_0-test-1/Page.svelte')
	},
	browser_2_0vs1_0Test2: {
		condition: async () => {
			return isExperimentArmActive('10004');
		},
		resolve: async () => await import('../_browser-3220-2_0-to-1_0-test-2/Page.svelte')
	},
	browser_2_0vs1_0Ctrl: {
		condition: async () => {
			return isExperimentArmActive('10025');
		},
		resolve: async () => await import('../_browser/Page.svelte')
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte')
	}
};

export { pageConditions };
